import { switchTo } from "./switch";

const COOKIE = "otridon_lang";
const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function remember(lang: string): void {
  const secure = location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE}=${lang}; Max-Age=31536000; Path=/; SameSite=Lax${secure}`;
}

export function initLang(): void {
  document.querySelectorAll<HTMLAnchorElement>("[data-lang-link]").forEach((a) =>
    a.addEventListener("click", (e) => {
      const lang = a.dataset.langLink ?? "en";
      remember(lang);
      if (reduced || a.getAttribute("aria-current") === "true" || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      const nameOf = (code: string) =>
        (document.querySelector(`.lang__list [data-lang-link="${code}"] .lang__name`)?.textContent ?? code.toUpperCase()).trim();
      const here = document.querySelector<HTMLElement>('.lang__list [aria-current="true"]')?.dataset.langLink ?? "en";
      switchTo(a.href, { name: nameOf(lang), lang }, { name: nameOf(here), lang: here });
    }),
  );
  document.querySelectorAll<HTMLElement>("[data-lang]").forEach((box) => {
    const button = box.querySelector<HTMLButtonElement>("[data-lang-btn]");
    const menu = box.querySelector<HTMLElement>("[data-lang-menu]");
    if (!button || !menu) return;
    const list = menu.querySelector<HTMLElement>(".lang__list");
    const search = menu.querySelector<HTMLInputElement>("[data-lang-search]");
    const none = menu.querySelector<HTMLElement>("[data-lang-none]");
    const items = Array.from(menu.querySelectorAll<HTMLLIElement>(".lang__list li"));
    const words = (li: HTMLLIElement) =>
      `${li.textContent ?? ""} ${li.dataset.langWords ?? ""}`.toLocaleLowerCase();
    const fold = (t: string) => t.normalize("NFD").replace(/\p{M}/gu, "").toLocaleLowerCase().trim();
    const filter = () => {
      const q = fold(search?.value ?? "");
      let shown = 0;
      for (const li of items) {
        const hit = !q || fold(words(li)).includes(q);
        li.hidden = !hit;
        if (hit) shown++;
      }
      if (none) none.hidden = shown > 0;
    };
    const visible = () =>
      Array.from(menu.querySelectorAll<HTMLAnchorElement>(".lang__list li:not([hidden]) a"));
    const set = (open: boolean) => {
      button.setAttribute("aria-expanded", String(open));
      menu.hidden = !open;
      box.classList.toggle("is-open", open);
      if (!open && search) {
        search.value = "";
        filter();
      }
    };
    search?.addEventListener("input", () => {
      filter();
      if (list) list.scrollTop = 0;
    });
    search?.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        visible()[0]?.click();
      }
    });
    button.addEventListener("click", () => {
      const open = button.getAttribute("aria-expanded") !== "true";
      set(open);
      if (!open) return;
      const current = menu.querySelector<HTMLElement>('[aria-current="true"]');
      if (list && current) {
        const l = list.getBoundingClientRect();
        const c = current.getBoundingClientRect();
        list.scrollTop += c.top - l.top - (l.height - c.height) / 2;
      }
      (search ?? current ?? menu.querySelector<HTMLElement>("a"))?.focus({ preventScroll: true });
    });
    document.addEventListener("click", (e) => {
      if (!box.contains(e.target as Node)) set(false);
    });
    menu.addEventListener("click", (e) => {
      if ((e.target as Element).closest("a")) set(false);
    });
    const away = (e: Event) => {
      if (!menu.hidden && !menu.contains(e.target as Node)) set(false);
    };
    for (const type of ["scroll", "wheel", "touchmove"])
      window.addEventListener(type, away, { passive: true });
    box.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !menu.hidden) {
        set(false);
        button.focus();
      }
      if ((e.key === "ArrowDown" || e.key === "ArrowUp") && !menu.hidden) {
        const links = visible();
        const i = links.indexOf(document.activeElement as HTMLAnchorElement);
        const down = e.key === "ArrowDown";
        if (!down && i <= 0 && search) search.focus();
        else links[down ? Math.min(i + 1, links.length - 1) : i - 1]?.focus();
        e.preventDefault();
      }
    });
  });
}
